import { useEffect, useState } from 'react';
import { equipmentService } from 'shared/services';
import { Option } from 'shared/types/general';

export const useAccessorEquipmentOptions = () => {
  const [equipments, setEquipments] = useState<Option[]>([]);

  useEffect(() => {
    equipmentService.getAllBaseInformation().then((res) => {
      setEquipments(
        res.map((eq) => ({
          id: +eq.id,
          code: `${eq.description} (SN ${eq.serial_number}) - (ID. ${eq.internal_id})`
        }))
      );
    });
  }, []);

  return { equipments };
};
